import { useDeferredValue, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../shared/button";
import { TCourseThemes } from "../types";
import CourseService from "../APIService/CourseService";
import { CourseTypeEnum } from "../enums";
import { CourseThemesList } from "../components/courseThemesList/courseThemesList";

export function Olympiades() {
  const [themes, setThemes] = useState<TCourseThemes[]>([]);
  const deferredThemes = useDeferredValue(themes);

  const fetchThemes = async () => {
    const response = await CourseService.getCourseGroupList({
      courseType: CourseTypeEnum.THEME,
      take: 10,
      page: 0,
    });
    return response || { data: [] };
  };

  useEffect(() => {
    fetchThemes().then((response) => {
      if (response && response.data) {
        setThemes([...response.data]);
      }
    });
  }, []);

  return (
    <div className={"MainPageGrid"}>
      <div>
        <h2 style={{ textAlign: "left" }}>ОЛИМПИАДНАЯ МАТЕМАТИКА</h2>

        <p>
          На 8 февраля 2026 года в публичном доступе 2400 задач для учеников 3-4
          класса, сгруппированных по 17 темам.
        </p>

        <CourseThemesList themes={deferredThemes.slice(0, 23)} />

        <Link to={"/theme"}>
          <Button>
            <span> Все темы</span>
          </Button>
        </Link>
      </div>
      <img width="295" height="253" src={"/images/movement2.svg"} alt="" />
    </div>
  );
}
